var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 24.037a8.037 8.037 0 0 0 7.596-10.67c-.13-.377.004-.804.35-1.004l3.858-2.227a.744.744 0 0 1 1.062.334A13.955 13.955 0 0 1 30 16c0 7.732-6.268 14-14 14S2 23.732 2 16c0-1.912.383-3.734 1.077-5.395a.743.743 0 0 1 1.065-.341l3.868 2.233c.34.196.477.616.354.99A8.037 8.037 0 0 0 16 24.037zM26.875 8.576a.743.743 0 0 0 .235-1.096A13.977 13.977 0 0 0 16 2 13.98 13.98 0 0 0 4.8 7.597a.744.744 0 0 0 .24 1.09l3.86 2.228c.345.2.78.103 1.041-.196a8.018 8.018 0 0 1 6.06-2.757 8.017 8.017 0 0 1 5.974 2.66c.263.292.692.383 1.032.187l3.87-2.234z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnus);
export default __webpack_public_path__ + "static/media/ONUS.2bf02c8a4cdb12bf43ea050247cba145.svg";
export { ForwardRef as ReactComponent };